"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_DEFAULTS = exports.FETCH_BUFFER_DEFAULTS = exports.FETCH_JSON_DEFAULTS = exports.FETCHER_DEFAULTS = void 0;
exports.FETCHER_DEFAULTS = {
    method: 'GET',
    attempts: 1,
    waitTime: '1s',
    timeout: '5m'
};
exports.FETCH_JSON_DEFAULTS = Object.assign(Object.assign({}, exports.FETCHER_DEFAULTS), { timeout: '30s', waitTime: '0.5s' });
exports.FETCH_BUFFER_DEFAULTS = Object.assign(Object.assign({}, exports.FETCHER_DEFAULTS), { timeout: '1m' });
exports.POST_DEFAULTS = Object.assign(Object.assign({}, exports.FETCHER_DEFAULTS), { method: 'POST' });
//# sourceMappingURL=FetcherConfiguration.js.map